// src/index.tsx
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";

import App from "./App";
import "./index.css";

import { initGA } from "./analytics/ga4";
import { RouterTracker } from "./analytics/RouterTracker";
import { reportWebVitals } from "./analytics/vitals";

import {msalInstance} from "./auth/msalInstance";  

const RootRouter: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        await msalInstance.initialize();               // MSAL ≥ 3.x
        const result = await msalInstance.handleRedirectPromise();
        if (result?.account) msalInstance.setActiveAccount(result.account);

        initGA();                                      // starts GA4 AFTER auth flow
      } catch (err: unknown) {
        /* eslint-disable-next-line no-console */
        console.error("MSAL redirect error:", err);
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  if (!loaded) return <div>Loading authentication…</div>;
  return <App />;
};

const Root: React.FC = () => (
  <HashRouter>
    <RouterTracker />                 {/* sends page_view on every hash change */}
    <MsalProvider instance={msalInstance}>
      <RootRouter />
    </MsalProvider>
  </HashRouter>
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Root />);

reportWebVitals();
